import { Link } from '@inertiajs/react';
import { useState } from 'react';
import { resolveLinkProps, buildSrcSet } from '../utils';

const SocialIcon = ({type, ...props}) => {
    const paths = {
        facebook: <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>,
        instagram: <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>,
        tiktok: <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/>,
        youtube: <path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>,
        twitter: <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>,
        linkedin: <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>,
        threads: <path d="M12.186 24h-.007c-3.581-.024-6.334-1.205-8.184-3.509C2.35 18.44 1.5 15.586 1.472 12.01v-.017c.03-3.579.879-6.43 2.525-8.482C5.845 1.205 8.6.024 12.18 0h.014c2.746.02 5.043.725 6.826 2.098 1.677 1.29 2.858 3.13 3.509 5.467l-2.04.569c-1.104-3.96-3.898-5.984-8.304-6.015-2.91.022-5.11.936-6.54 2.717C4.307 6.504 3.616 8.914 3.589 12c.027 3.086.718 5.496 2.057 7.164 1.43 1.783 3.631 2.698 6.54 2.717 2.623-.02 4.358-.631 5.8-2.045 1.647-1.613 1.618-3.593 1.09-4.798-.31-.71-.873-1.3-1.634-1.75-.192 1.352-.622 2.446-1.284 3.272-.886 1.102-2.14 1.704-3.73 1.79-1.202.065-2.361-.218-3.259-.801-1.063-.689-1.685-1.74-1.752-2.96-.065-1.187.408-2.26 1.33-3.017.88-.724 2.105-1.14 3.544-1.205 1.035-.046 1.988.04 2.862.256-.107-.88-.47-1.542-1.09-1.968-.71-.488-1.724-.737-3.014-.737l-.033.002c-1.382.016-2.478.393-3.258 1.12l-1.394-1.5C7.4 5.67 8.93 5.13 10.783 5.106h.046c1.756 0 3.183.39 4.243 1.158 1.136.824 1.847 2.03 2.113 3.585.523.132 1.013.31 1.472.539 1.16.577 2.065 1.44 2.615 2.5.796 1.535.856 4.09-1.197 6.106-1.786 1.756-4.012 2.56-7.01 2.582-.352.017-.676.024-.88.024zM11.096 14.8c-1.052.046-1.876.312-2.387.768-.422.376-.587.822-.559 1.305.04.676.397 1.186.994 1.573.674.437 1.504.608 2.332.56 1.088-.059 1.928-.454 2.498-1.176.445-.564.754-1.334.914-2.29-.903-.272-1.9-.415-2.987-.415-.268 0-.54.01-.805.03v-.355z"/>,
    };
    return paths[type] ? <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" {...props}>{paths[type]}</svg> : null;
};

const AppStoreButtons = ({ appStoreUrl, playStoreUrl, huaweiStoreUrl }) => {
    if (!appStoreUrl && !playStoreUrl && !huaweiStoreUrl) return null;
    return (
        <div className="flex flex-wrap gap-2">
            {appStoreUrl && (
                <a href={appStoreUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 rounded-lg px-3.5 py-2 transition-colors">
                    <svg className="w-5 h-5 text-white" viewBox="0 0 24 24" fill="currentColor"><path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/></svg>
                    <div className="text-left"><p className="text-[8px] text-white/60 leading-none">Descargar en</p><p className="text-xs font-semibold text-white leading-tight">App Store</p></div>
                </a>
            )}
            {playStoreUrl && (
                <a href={playStoreUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 rounded-lg px-3.5 py-2 transition-colors">
                    <svg className="w-5 h-5 text-white" viewBox="0 0 24 24" fill="currentColor"><path d="M3.609 1.814L13.792 12 3.61 22.186a.996.996 0 01-.61-.92V2.734a1 1 0 01.609-.92zm10.89 10.893l2.302 2.302-10.937 6.333 8.635-8.635zm3.199-3.198l2.807 1.626a1 1 0 010 1.73l-2.808 1.626L15.206 12l2.492-2.491zM5.864 2.658L16.8 8.99l-2.302 2.302-8.634-8.634z"/></svg>
                    <div className="text-left"><p className="text-[8px] text-white/60 leading-none">Disponible en</p><p className="text-xs font-semibold text-white leading-tight">Google Play</p></div>
                </a>
            )}
            {huaweiStoreUrl && (
                <a href={huaweiStoreUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 rounded-lg px-3.5 py-2 transition-colors">
                    <svg className="w-5 h-5 text-white" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/></svg>
                    <div className="text-left"><p className="text-[8px] text-white/60 leading-none">Explorar en</p><p className="text-xs font-semibold text-white leading-tight">AppGallery</p></div>
                </a>
            )}
        </div>
    );
};

export default function LandingFooter({ block, brand, navLinks, primaryColor, secondaryColor }) {
    const fc = block?.config || {};
    const variant = fc.variant || 'full';
    const showLogo = fc.show_logo !== false;
    const showContact = fc.show_contact !== false;
    const showNav = fc.show_nav !== false;
    const showSocial = fc.show_social !== false;
    const showCopyright = fc.show_copyright !== false;
    const bgColor = fc.bg_color || secondaryColor;
    const bgColorEnd = fc.bg_color_end || primaryColor;
    const bgStyle = fc.bg_style || 'solid';
    const footerBg = bgStyle === 'gradient-linear' ? { background: `linear-gradient(180deg, ${bgColor}, ${bgColorEnd})` }
        : bgStyle === 'gradient-radial' ? { background: `radial-gradient(ellipse at center top, ${bgColor}, ${bgColorEnd})` }
        : bgStyle === 'gradient-diagonal' ? { background: `linear-gradient(135deg, ${bgColor}, ${bgColorEnd})` }
        : { backgroundColor: bgColor };
    const footerSpacing = fc.footer_spacing || 'normal';
    const spacingClass = footerSpacing === 'compact' ? 'py-4' : footerSpacing === 'spacious' ? 'py-16' : footerSpacing === 'extra' ? 'py-24' : 'py-12';
    const copyrightText = fc.copyright_text || `\u00a9 ${new Date().getFullYear()} ${brand.name}. Todos los derechos reservados.`;

    const showNewsletter = fc.show_newsletter === true;
    const appStoreProps = { appStoreUrl: fc.app_store_url, playStoreUrl: fc.play_store_url, huaweiStoreUrl: fc.huawei_store_url };
    const hasAppStores = fc.app_store_url || fc.play_store_url || fc.huawei_store_url;
    const validSocials = ['facebook', 'instagram', 'tiktok', 'youtube', 'twitter', 'linkedin', 'threads'];
    const socials = Object.entries(brand.social_links || {}).filter(([k, v]) => v && validSocials.includes(k));
    const smoothScroll = (e, id) => { e.preventDefault(); document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' }); };

    // Logo config
    const footerLogoStyle = fc.footer_logo_style || 'default';
    const footerLogoSize = fc.footer_logo_size || 40;
    const footerLogoSizeMobile = fc.footer_logo_size_mobile || Math.min(footerLogoSize, 32);
    const footerAnimation = fc.footer_animation || 'none';

    const FooterLogo = ({className = '', dark = true}) => {
        if (!showLogo) return null;
        const nameColor = dark ? '#ffffff' : (primaryColor || '#111827');
        const logoUrl = dark ? brand.logo_white_url : brand.logo_url;

        if (footerLogoStyle === 'text-only') {
            return <h3 className={`text-xl font-bold ${className}`} style={{color: nameColor}}>{brand.name}</h3>;
        }
        const logoImg = logoUrl
            ? <img src={logoUrl} alt={brand.name} decoding="async" className={`lm-flogo ${className}`}/>
            : <h3 className={`text-xl font-bold ${className}`} style={{color: nameColor}}>{brand.name}</h3>;

        if (footerLogoStyle === 'with-name' && logoUrl) {
            return <div className={`flex items-center gap-3 ${className}`}>
                <img src={logoUrl} alt={brand.name} decoding="async" className="lm-flogo"/>
                <span className="text-lg font-semibold" style={{color: nameColor}}>{brand.name}</span>
            </div>;
        }
        return logoImg;
    };

    const animClass = footerAnimation !== 'none' ? ' lm-footer-anim' : '';
    const footerCss = <style>{`
        .lm-flogo{height:${footerLogoSizeMobile}px;width:auto;object-fit:contain}
        @media(min-width:640px){.lm-flogo{height:${footerLogoSize}px}}
        ${footerAnimation === 'fade-up' ? `@keyframes lmFooterFadeUp{from{opacity:0;transform:translateY(30px)}to{opacity:1;transform:none}}.lm-footer-anim>*{animation:lmFooterFadeUp .6s ease-out both}` : ''}
        ${footerAnimation === 'stagger' ? `@keyframes lmFooterStagger{from{opacity:0;transform:translateY(20px)}to{opacity:1;transform:none}}.lm-footer-anim [class*="grid"]>*,.lm-footer-anim>div>*{animation:lmFooterStagger .5s ease-out both}.lm-footer-anim [class*="grid"]>*:nth-child(1),.lm-footer-anim>div>*:nth-child(1){animation-delay:0ms}.lm-footer-anim [class*="grid"]>*:nth-child(2),.lm-footer-anim>div>*:nth-child(2){animation-delay:100ms}.lm-footer-anim [class*="grid"]>*:nth-child(3),.lm-footer-anim>div>*:nth-child(3){animation-delay:200ms}.lm-footer-anim [class*="grid"]>*:nth-child(4),.lm-footer-anim>div>*:nth-child(4){animation-delay:300ms}.lm-footer-anim [class*="grid"]>*:nth-child(5),.lm-footer-anim>div>*:nth-child(5){animation-delay:400ms}` : ''}
        ${footerAnimation === 'slide-in' ? `@keyframes lmFooterSlideL{from{opacity:0;transform:translateX(-30px)}to{opacity:1;transform:none}}@keyframes lmFooterSlideR{from{opacity:0;transform:translateX(30px)}to{opacity:1;transform:none}}.lm-footer-anim [class*="grid"]>*:nth-child(odd),.lm-footer-anim>div>*:nth-child(odd){animation:lmFooterSlideL .5s ease-out both}.lm-footer-anim [class*="grid"]>*:nth-child(even),.lm-footer-anim>div>*:nth-child(even){animation:lmFooterSlideR .5s ease-out both}.lm-footer-anim [class*="grid"]>*:nth-child(2),.lm-footer-anim>div>*:nth-child(2){animation-delay:100ms}.lm-footer-anim [class*="grid"]>*:nth-child(3),.lm-footer-anim>div>*:nth-child(3){animation-delay:200ms}.lm-footer-anim [class*="grid"]>*:nth-child(4),.lm-footer-anim>div>*:nth-child(4){animation-delay:300ms}` : ''}
    `}</style>;

    const FooterNewsletter = () => {
        const [email, setEmail] = useState('');
        const [sent, setSent] = useState(false);
        const handleSubmit = (e) => { e.preventDefault(); if (email) setSent(true); };
        if (sent) return (
            <div className="flex items-center gap-2 text-sm text-green-400">
                <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7"/></svg>
                Gracias por suscribirte
            </div>
        );
        return (
            <form onSubmit={handleSubmit} className="flex items-center gap-0 max-w-sm">
                <div className="relative flex-1">
                    <svg className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-white/30" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
                    </svg>
                    <input type="email" value={email} onChange={e => setEmail(e.target.value)} required
                        placeholder="tu@email.com"
                        className="w-full bg-white/10 border border-white/20 rounded-l-xl pl-10 pr-3 py-2.5 text-sm text-white placeholder-white/40 focus:outline-none focus:ring-2 focus:ring-white/30 focus:border-transparent"/>
                </div>
                <button type="submit" className="px-5 py-2.5 rounded-r-xl text-sm font-semibold bg-white text-gray-900 hover:bg-gray-100 transition-colors shrink-0">
                    Suscribirse
                </button>
            </form>
        );
    };

    // -- Simple (1 line) --
    if (variant === 'simple') {
        return (
            <footer className={`text-white ${spacingClass}${animClass}`} style={footerBg}>
                {footerCss}
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    {showNewsletter && (
                        <div className="flex flex-col items-center gap-2 mb-6 pb-6 border-b border-white/20">
                            <h4 className="font-semibold text-sm">Suscribete</h4>
                            <FooterNewsletter />
                        </div>
                    )}
                    <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
                        <div className="flex items-center gap-4">
                            <FooterLogo/>
                            {showCopyright && <span className="text-sm text-white/50">{copyrightText}</span>}
                        </div>
                        <div className="flex items-center gap-4">
                            {(brand.privacy_url || brand.terms_url) && (
                                <div className="flex items-center gap-3">
                                    {brand.privacy_url && <a href={brand.privacy_url} target="_blank" rel="noopener noreferrer" className="text-xs text-white/40 hover:text-white/70 transition-colors">Politica de Privacidad</a>}
                                    {brand.privacy_url && brand.terms_url && <span className="text-white/20">|</span>}
                                    {brand.terms_url && <a href={brand.terms_url} target="_blank" rel="noopener noreferrer" className="text-xs text-white/40 hover:text-white/70 transition-colors">Terminos y Condiciones</a>}
                                </div>
                            )}
                            {showSocial && socials.length > 0 && (
                                <div className="flex gap-3">
                                    {socials.map(([key, url]) => (
                                        <a key={key} href={url} target="_blank" rel="noopener noreferrer" className="text-white/50 hover:text-white transition-colors">
                                            <SocialIcon type={key}/>
                                        </a>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </footer>
        );
    }

    // -- Centered --
    if (variant === 'centered') {
        return (
            <footer className={`text-white ${spacingClass}${animClass}`} style={footerBg}>
                {footerCss}
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                    <FooterLogo className="mx-auto mb-4"/>
                    {brand.slogan && <p className="text-white/60 text-sm mb-6">{brand.slogan}</p>}
                    {showNav && navLinks.length > 0 && (
                        <div className="flex flex-wrap justify-center gap-4 mb-6">
                            {navLinks.map(link => (
                                <a key={link.id} href={link.href || `#${link.id}`} onClick={link.href ? undefined : e => smoothScroll(e, link.id)}
                                    className="text-sm text-white/60 hover:text-white transition-colors">{link.label}</a>
                            ))}
                        </div>
                    )}
                    {showSocial && socials.length > 0 && (
                        <div className="flex justify-center gap-3 mb-6">
                            {socials.map(([key, url]) => (
                                <a key={key} href={url} target="_blank" rel="noopener noreferrer"
                                    className="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors">
                                    <SocialIcon type={key}/>
                                </a>
                            ))}
                        </div>
                    )}
                    {showNewsletter && (
                        <div className="flex flex-col items-center gap-2 mb-6">
                            <h4 className="font-semibold text-sm">Suscribete</h4>
                            <FooterNewsletter />
                        </div>
                    )}
                    {hasAppStores && (
                        <div className="flex justify-center mb-6">
                            <AppStoreButtons {...appStoreProps}/>
                        </div>
                    )}
                    {showCopyright && (
                        <div>
                            <p className="text-sm text-white/40">{copyrightText}</p>
                            {(brand.privacy_url || brand.terms_url) && (
                                <div className="flex items-center justify-center gap-3 mt-2">
                                    {brand.privacy_url && <a href={brand.privacy_url} target="_blank" rel="noopener noreferrer" className="text-xs text-white/40 hover:text-white/70 transition-colors">Politica de Privacidad</a>}
                                    {brand.privacy_url && brand.terms_url && <span className="text-white/20">|</span>}
                                    {brand.terms_url && <a href={brand.terms_url} target="_blank" rel="noopener noreferrer" className="text-xs text-white/40 hover:text-white/70 transition-colors">Terminos y Condiciones</a>}
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </footer>
        );
    }

    // -- Minimal --
    if (variant === 'minimal') {
        return (
            <footer className={`text-white ${spacingClass}${animClass}`} style={footerBg}>
                {footerCss}
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                    {showCopyright && <p className="text-xs text-white/40">{copyrightText}</p>}
                </div>
            </footer>
        );
    }

    // -- CTA Footer --
    if (variant === 'cta-footer') {
        const content = block?.content || {};
        const linkColumns = (content.link_columns || []).filter(col => col.title || col.links_text);
        const parseLinkCol = (col) => {
            if (!col.links_text) return [];
            return col.links_text.split('\n').map(l => { const [label, url] = l.split('|'); return { label: label?.trim(), url: url?.trim() || '#' }; }).filter(l => l.label);
        };
        const totalCols = 1 + (showContact ? 1 : 0) + linkColumns.length + (showSocial && socials.length > 0 ? 1 : 0);
        const gridClass = totalCols <= 3 ? 'md:grid-cols-3' : totalCols === 4 ? 'md:grid-cols-4' : 'md:grid-cols-5';
        return (
            <footer className={`${spacingClass}${animClass}`} style={footerBg}>
                {footerCss}
                {/* CTA area */}
                <div className="py-12 md:py-16 border-b border-white/10">
                    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
                        <h2 className="text-2xl md:text-3xl font-bold mb-4">{fc.cta_title || 'Comienza tu camino hoy'}</h2>
                        {fc.cta_subtitle && <p className="text-white/60 mb-6">{fc.cta_subtitle}</p>}
                        {fc.cta_text && (
                            <a {...resolveLinkProps(fc.cta_link || '#contact')} className="inline-block px-8 py-3 bg-white rounded-full font-semibold text-sm hover:shadow-lg hover:scale-105 transition-all" style={{color: bgColor}}>
                                {fc.cta_text}
                            </a>
                        )}
                    </div>
                </div>
                {/* Standard columns */}
                <div className="py-10">
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                        <div className={`grid grid-cols-1 ${gridClass} gap-8`}>
                            <div>
                                <FooterLogo className="mb-4"/>
                                {brand.slogan && <p className="text-white/70 text-sm">{brand.slogan}</p>}
                            </div>
                            <div>
                                {showContact && (
                                    <>
                                        <h4 className="font-semibold text-white mb-3">Contacto</h4>
                                        <div className="space-y-2 text-sm text-white/70">
                                            {brand.contact_email && <a href={`mailto:${brand.contact_email}`} className="block hover:text-white transition-colors">{brand.contact_email}</a>}
                                            {brand.contact_phone && <a href={`tel:${brand.contact_phone}`} className="block hover:text-white transition-colors">{brand.contact_phone}</a>}
                                            {brand.address && (
                                                <div className="flex items-start gap-1.5">
                                                    <svg className="w-4 h-4 shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"/></svg>
                                                    <span>{brand.address}</span>
                                                </div>
                                            )}
                                            {brand.business_hours && (
                                                <div className="flex items-start gap-1.5">
                                                    <svg className="w-4 h-4 shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
                                                    <span>{brand.business_hours}</span>
                                                </div>
                                            )}
                                        </div>
                                    </>
                                )}
                                {showNav && navLinks.length > 0 && (
                                    <div className="mt-4 space-y-1">
                                        {navLinks.map(link => (
                                            <a key={link.id} href={link.href || `#${link.id}`} onClick={link.href ? undefined : e => smoothScroll(e, link.id)}
                                                className="block text-sm text-white/50 hover:text-white/80 transition-colors">{link.label}</a>
                                        ))}
                                    </div>
                                )}
                            </div>
                            {linkColumns.map((col, ci) => {
                                const links = parseLinkCol(col);
                                if (links.length === 0 && !col.title) return null;
                                return (
                                    <div key={ci}>
                                        {col.title && <h4 className="font-semibold text-white mb-3">{col.title}</h4>}
                                        <div className="space-y-1">
                                            {links.map((link, li) => (
                                                <a key={li} {...resolveLinkProps(link.url)} className="block text-sm text-white/50 hover:text-white/80 transition-colors">{link.label}</a>
                                            ))}
                                        </div>
                                    </div>
                                );
                            })}
                            <div>
                                {showSocial && socials.length > 0 && (
                                    <>
                                        <h4 className="font-semibold text-white mb-3">Redes sociales</h4>
                                        <div className="flex gap-3">
                                            {socials.map(([key, url]) => (
                                                <a key={key} href={url} target="_blank" rel="noopener noreferrer"
                                                    className="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center text-white transition-colors">
                                                    <SocialIcon type={key}/>
                                                </a>
                                            ))}
                                        </div>
                                    </>
                                )}
                                {showNewsletter && (
                                    <div className="mt-4">
                                        <h4 className="font-semibold text-white mb-3">Suscribete</h4>
                                        <FooterNewsletter />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                {showCopyright && (
                    <div className="border-t border-white/20 py-4 text-center text-sm text-white/50 px-4">
                        <p>{copyrightText}</p>
                        {(brand.privacy_url || brand.terms_url) && (
                            <div className="flex items-center justify-center gap-3 mt-1">
                                {brand.privacy_url && <a href={brand.privacy_url} target="_blank" rel="noopener noreferrer" className="text-xs text-white/40 hover:text-white/70 transition-colors">Politica de Privacidad</a>}
                                {brand.privacy_url && brand.terms_url && <span className="text-white/20">|</span>}
                                {brand.terms_url && <a href={brand.terms_url} target="_blank" rel="noopener noreferrer" className="text-xs text-white/40 hover:text-white/70 transition-colors">Terminos y Condiciones</a>}
                            </div>
                        )}
                    </div>
                )}
            </footer>
        );
    }

    // -- Big Brand (giant watermark) --
    if (variant === 'big-brand') {
        return (
            <footer className={`text-white relative overflow-hidden ${spacingClass}${animClass}`} style={footerBg}>
                {footerCss}
                {/* Giant watermark */}
                <div className="absolute inset-0 flex items-center justify-center pointer-events-none select-none overflow-hidden">
                    <span className="text-[8rem] md:text-[12rem] font-black text-white/[0.03] whitespace-nowrap">{brand.name}</span>
                </div>
                {/* Content */}
                <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="py-12 flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
                        <div className="flex items-center gap-4">
                            <FooterLogo/>
                            {brand.slogan && <p className="text-white/60 text-sm">{brand.slogan}</p>}
                        </div>
                        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-6">
                            {showNav && navLinks.length > 0 && (
                                <div className="flex flex-wrap gap-4">
                                    {navLinks.map(link => (
                                        <a key={link.id} href={link.href || `#${link.id}`} onClick={link.href ? undefined : e => smoothScroll(e, link.id)}
                                            className="text-sm text-white/60 hover:text-white transition-colors">{link.label}</a>
                                    ))}
                                </div>
                            )}
                            {showSocial && socials.length > 0 && (
                                <div className="flex gap-3">
                                    {socials.map(([key, url]) => (
                                        <a key={key} href={url} target="_blank" rel="noopener noreferrer"
                                            className="text-white/50 hover:text-white transition-colors">
                                            <SocialIcon type={key}/>
                                        </a>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                    {showNewsletter && (
                        <div className="pb-6 flex flex-col items-center gap-2">
                            <h4 className="font-semibold text-sm">Suscribete</h4>
                            <FooterNewsletter />
                        </div>
                    )}
                    {showCopyright && (
                        <div className="border-t border-white/10 py-4 flex flex-col sm:flex-row items-center justify-between gap-4">
                            <div>
                                <span className="text-sm text-white/40">{copyrightText}</span>
                                {(brand.privacy_url || brand.terms_url) && (
                                    <div className="flex items-center gap-3 mt-1">
                                        {brand.privacy_url && <a href={brand.privacy_url} target="_blank" rel="noopener noreferrer" className="text-xs text-white/30 hover:text-white/60 transition-colors">Politica de Privacidad</a>}
                                        {brand.privacy_url && brand.terms_url && <span className="text-white/20">|</span>}
                                        {brand.terms_url && <a href={brand.terms_url} target="_blank" rel="noopener noreferrer" className="text-xs text-white/30 hover:text-white/60 transition-colors">Terminos y Condiciones</a>}
                                    </div>
                                )}
                            </div>
                            {showContact && (
                                <div className="flex flex-col items-end gap-1 text-sm text-white/40">
                                    <div className="flex items-center gap-4">
                                        {brand.contact_email && <a href={`mailto:${brand.contact_email}`} className="hover:text-white/70 transition-colors">{brand.contact_email}</a>}
                                        {brand.contact_phone && <a href={`tel:${brand.contact_phone}`} className="hover:text-white/70 transition-colors">{brand.contact_phone}</a>}
                                    </div>
                                    {brand.address && <span className="text-xs">{brand.address}</span>}
                                    {brand.business_hours && <span className="text-xs">{brand.business_hours}</span>}
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </footer>
        );
    }

    // -- Two Tone (split two-color) --
    if (variant === 'two-tone') {
        return (
            <footer className={animClass.trim()}>
                {footerCss}
                {/* Top half — light */}
                <div className="bg-gray-100 text-gray-800 py-12">
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
                            <div className="flex items-center gap-4">
                                <FooterLogo dark={false}/>
                            </div>
                            {showNav && navLinks.length > 0 && (
                                <div className="flex flex-wrap gap-5">
                                    {navLinks.map(link => (
                                        <a key={link.id} href={link.href || `#${link.id}`} onClick={link.href ? undefined : e => smoothScroll(e, link.id)}
                                            className="text-sm text-gray-500 hover:text-gray-800 transition-colors">{link.label}</a>
                                    ))}
                                </div>
                            )}
                        </div>
                        {brand.slogan && <p className="text-gray-500 text-sm mt-4">{brand.slogan}</p>}
                        {showNewsletter && (
                            <div className="mt-8 flex flex-col items-start gap-2">
                                <h4 className="font-semibold text-sm text-gray-700">Suscribete a nuestro newsletter</h4>
                                <FooterNewsletter />
                            </div>
                        )}
                    </div>
                </div>
                {/* Bottom half — dark */}
                <div className="text-white py-8" style={footerBg}>
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row items-center justify-between gap-6">
                        <div className="flex items-center gap-6">
                            {showSocial && socials.length > 0 && (
                                <div className="flex gap-3">
                                    {socials.map(([key, url]) => (
                                        <a key={key} href={url} target="_blank" rel="noopener noreferrer"
                                            className="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors">
                                            <SocialIcon type={key}/>
                                        </a>
                                    ))}
                                </div>
                            )}
                            {showContact && (
                                <div className="flex flex-wrap items-center gap-4 text-sm text-white/70">
                                    {brand.contact_email && <a href={`mailto:${brand.contact_email}`} className="hover:text-white transition-colors">{brand.contact_email}</a>}
                                    {brand.contact_phone && <a href={`tel:${brand.contact_phone}`} className="hover:text-white transition-colors">{brand.contact_phone}</a>}
                                    {brand.address && (
                                        <span className="inline-flex items-center gap-1">
                                            <svg className="w-3.5 h-3.5 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"/></svg>
                                            {brand.address}
                                        </span>
                                    )}
                                    {brand.business_hours && (
                                        <span className="inline-flex items-center gap-1">
                                            <svg className="w-3.5 h-3.5 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
                                            {brand.business_hours}
                                        </span>
                                    )}
                                </div>
                            )}
                        </div>
                        <div className="flex flex-col items-center sm:items-end gap-1">
                            {showCopyright && <span className="text-sm text-white/40">{copyrightText}</span>}
                            {(brand.privacy_url || brand.terms_url) && (
                                <div className="flex items-center gap-3">
                                    {brand.privacy_url && <a href={brand.privacy_url} target="_blank" rel="noopener noreferrer" className="text-xs text-white/30 hover:text-white/60 transition-colors">Politica de Privacidad</a>}
                                    {brand.privacy_url && brand.terms_url && <span className="text-white/20">|</span>}
                                    {brand.terms_url && <a href={brand.terms_url} target="_blank" rel="noopener noreferrer" className="text-xs text-white/30 hover:text-white/60 transition-colors">Terminos y Condiciones</a>}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </footer>
        );
    }

    // -- Stacked (centered vertical) --
    if (variant === 'stacked') {
        return (
            <footer className={`text-white ${spacingClass}${animClass}`} style={footerBg}>
                {footerCss}
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center text-center gap-6">
                    {/* Logo / Brand name */}
                    <FooterLogo/>
                    {/* Slogan */}
                    {brand.slogan && <p className="text-white/60 text-sm max-w-md">{brand.slogan}</p>}
                    {/* Decorative line */}
                    <div className="w-16 h-0.5 bg-white/20 mx-auto"></div>
                    {/* Nav links */}
                    {showNav && navLinks.length > 0 && (
                        <div className="flex flex-wrap justify-center gap-6">
                            {navLinks.map(link => (
                                <a key={link.id} href={link.href || `#${link.id}`} onClick={link.href ? undefined : e => smoothScroll(e, link.id)}
                                    className="text-sm text-white/60 hover:text-white transition-colors">{link.label}</a>
                            ))}
                        </div>
                    )}
                    {/* Social icons */}
                    {showSocial && socials.length > 0 && (
                        <div className="flex justify-center gap-4">
                            {socials.map(([key, url]) => (
                                <a key={key} href={url} target="_blank" rel="noopener noreferrer"
                                    className="w-12 h-12 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors">
                                    <SocialIcon type={key}/>
                                </a>
                            ))}
                        </div>
                    )}
                    {/* App Store buttons */}
                    {hasAppStores && (
                        <div className="flex justify-center">
                            <AppStoreButtons {...appStoreProps}/>
                        </div>
                    )}
                    {/* Newsletter */}
                    {showNewsletter && (
                        <div className="flex flex-col items-center gap-2">
                            <h4 className="font-semibold text-sm">Suscribete</h4>
                            <FooterNewsletter />
                        </div>
                    )}
                    {/* Decorative line */}
                    <div className="w-16 h-0.5 bg-white/20 mx-auto"></div>
                    {/* Copyright */}
                    {showCopyright && (
                        <div>
                            <p className="text-xs text-white/40">{copyrightText}</p>
                            {(brand.privacy_url || brand.terms_url) && (
                                <div className="flex items-center justify-center gap-3 mt-2">
                                    {brand.privacy_url && <a href={brand.privacy_url} target="_blank" rel="noopener noreferrer" className="text-xs text-white/40 hover:text-white/70 transition-colors">Politica de Privacidad</a>}
                                    {brand.privacy_url && brand.terms_url && <span className="text-white/20">|</span>}
                                    {brand.terms_url && <a href={brand.terms_url} target="_blank" rel="noopener noreferrer" className="text-xs text-white/40 hover:text-white/70 transition-colors">Terminos y Condiciones</a>}
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </footer>
        );
    }

    // -- Contact Highlight (contact as protagonist) --
    if (variant === 'contact-highlight') {
        const hasPhone = !!brand.contact_phone;
        const hasEmail = !!brand.contact_email;
        const hasAddress = !!brand.address;
        const hasWhatsApp = !!(brand.social_links?.whatsapp);
        const hasBusinessHours = !!brand.business_hours;
        const hasAnyContact = hasPhone || hasEmail || hasAddress || hasWhatsApp || hasBusinessHours;
        return (
            <footer className={`text-white ${spacingClass}${animClass}`} style={footerBg}>
                {footerCss}
                {/* Contact cards */}
                {showContact && hasAnyContact && (
                    <div className="py-12">
                        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                                {hasPhone && (
                                    <div className="bg-white/10 rounded-2xl p-6 text-center">
                                        <div className="w-12 h-12 mx-auto rounded-full bg-white/10 flex items-center justify-center mb-3">
                                            <svg className="w-6 h-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/>
                                            </svg>
                                        </div>
                                        <p className="text-xs text-white/50 mb-1">Llamanos</p>
                                        <a href={`tel:${brand.contact_phone}`} className="text-lg font-semibold hover:text-white/80 transition-colors">{brand.contact_phone}</a>
                                    </div>
                                )}
                                {hasEmail && (
                                    <div className="bg-white/10 rounded-2xl p-6 text-center">
                                        <div className="w-12 h-12 mx-auto rounded-full bg-white/10 flex items-center justify-center mb-3">
                                            <svg className="w-6 h-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
                                            </svg>
                                        </div>
                                        <p className="text-xs text-white/50 mb-1">Escribenos</p>
                                        <a href={`mailto:${brand.contact_email}`} className="text-lg font-semibold hover:text-white/80 transition-colors">{brand.contact_email}</a>
                                    </div>
                                )}
                                {hasAddress ? (
                                    <div className="bg-white/10 rounded-2xl p-6 text-center">
                                        <div className="w-12 h-12 mx-auto rounded-full bg-white/10 flex items-center justify-center mb-3">
                                            <svg className="w-6 h-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/>
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"/>
                                            </svg>
                                        </div>
                                        <p className="text-xs text-white/50 mb-1">Visitanos</p>
                                        <p className="text-lg font-semibold">{brand.address}</p>
                                    </div>
                                ) : hasWhatsApp && (
                                    <div className="bg-white/10 rounded-2xl p-6 text-center">
                                        <div className="w-12 h-12 mx-auto rounded-full bg-white/10 flex items-center justify-center mb-3">
                                            <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 24 24">
                                                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
                                                <path d="M12 0C5.373 0 0 5.373 0 12c0 2.125.553 4.12 1.522 5.857L0 24l6.335-1.652A11.943 11.943 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.82c-1.978 0-3.81-.577-5.36-1.566l-.384-.228-3.762.982.998-3.648-.255-.398A9.818 9.818 0 012.18 12C2.18 6.58 6.58 2.18 12 2.18S21.82 6.58 21.82 12 17.42 21.82 12 21.82z"/>
                                            </svg>
                                        </div>
                                        <p className="text-xs text-white/50 mb-1">WhatsApp</p>
                                        <a href={brand.social_links.whatsapp} target="_blank" rel="noopener noreferrer" className="text-lg font-semibold hover:text-white/80 transition-colors">Escribenos</a>
                                    </div>
                                )}
                            </div>
                            {hasBusinessHours && (
                                <div className="mt-4 text-center">
                                    <div className="inline-flex items-center gap-2 text-sm text-white/60">
                                        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
                                        <span>{brand.business_hours}</span>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                )}
                {/* Compact bottom bar */}
                <div className="border-t border-white/10 py-6">
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row items-center justify-between gap-4">
                        <div className="flex items-center gap-4">
                            <FooterLogo/>
                            {showNav && navLinks.length > 0 && (
                                <div className="flex flex-wrap gap-4">
                                    {navLinks.map(link => (
                                        <a key={link.id} href={link.href || `#${link.id}`} onClick={link.href ? undefined : e => smoothScroll(e, link.id)}
                                            className="text-xs text-white/50 hover:text-white/80 transition-colors">{link.label}</a>
                                    ))}
                                </div>
                            )}
                        </div>
                        <div className="flex items-center gap-4">
                            {showSocial && socials.length > 0 && (
                                <div className="flex gap-2">
                                    {socials.map(([key, url]) => (
                                        <a key={key} href={url} target="_blank" rel="noopener noreferrer"
                                            className="text-white/40 hover:text-white transition-colors">
                                            <SocialIcon type={key}/>
                                        </a>
                                    ))}
                                </div>
                            )}
                            <div className="flex flex-col items-end gap-1">
                                {showCopyright && <span className="text-xs text-white/40">{copyrightText}</span>}
                                {(brand.privacy_url || brand.terms_url) && (
                                    <div className="flex items-center gap-3">
                                        {brand.privacy_url && <a href={brand.privacy_url} target="_blank" rel="noopener noreferrer" className="text-xs text-white/30 hover:text-white/60 transition-colors">Politica de Privacidad</a>}
                                        {brand.privacy_url && brand.terms_url && <span className="text-white/20">|</span>}
                                        {brand.terms_url && <a href={brand.terms_url} target="_blank" rel="noopener noreferrer" className="text-xs text-white/30 hover:text-white/60 transition-colors">Terminos y Condiciones</a>}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                {showNewsletter && (
                    <div className="border-t border-white/10 py-6">
                        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center gap-2">
                            <h4 className="font-semibold text-sm">Suscribete</h4>
                            <FooterNewsletter />
                        </div>
                    </div>
                )}
            </footer>
        );
    }

    // -- Full (default) + wave-top --
    const isWaveTop = variant === 'wave-top';
    const content = block?.content || {};
    const linkColumns = (content.link_columns || []).filter(col => col.title || col.links_text);
    const parseLinkCol = (col) => {
        if (!col.links_text) return [];
        return col.links_text.split('\n').map(l => { const [label, url] = l.split('|'); return { label: label?.trim(), url: url?.trim() || '#' }; }).filter(l => l.label);
    };
    const totalCols = 1 + (showContact ? 1 : 0) + linkColumns.length + ((showSocial && socials.length > 0) || showNewsletter ? 1 : 0);
    const gridClass = totalCols <= 3 ? 'md:grid-cols-3' : totalCols === 4 ? 'md:grid-cols-4' : 'md:grid-cols-5';

    return (
        <>
            {isWaveTop && (
                <div style={{marginBottom: -2}}>
                    <svg viewBox="0 0 1440 80" preserveAspectRatio="none" className="w-full h-12 md:h-16 block" fill={bgColor}>
                        <path d="M0,40 C320,80 640,0 960,40 C1280,80 1440,20 1440,20 L1440,80 L0,80 Z"/>
                    </svg>
                </div>
            )}
            <footer className={`text-white ${spacingClass}${animClass}`} style={footerBg}>
                {footerCss}
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className={`grid grid-cols-1 ${gridClass} gap-8`}>
                        <div>
                            <FooterLogo className="mb-4"/>
                            {brand.slogan && <p className="text-white/70 text-sm">{brand.slogan}</p>}
                        </div>
                        <div>
                            {showContact && (
                                <>
                                    <h4 className="font-semibold mb-3">Contacto</h4>
                                    <div className="space-y-2 text-sm text-white/70">
                                        {brand.contact_email && <a href={`mailto:${brand.contact_email}`} className="block hover:text-white transition-colors">{brand.contact_email}</a>}
                                        {brand.contact_phone && <a href={`tel:${brand.contact_phone}`} className="block hover:text-white transition-colors">{brand.contact_phone}</a>}
                                        {brand.address && (
                                            <div className="flex items-start gap-1.5">
                                                <svg className="w-4 h-4 shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"/></svg>
                                                <span>{brand.address}</span>
                                            </div>
                                        )}
                                        {brand.business_hours && (
                                            <div className="flex items-start gap-1.5">
                                                <svg className="w-4 h-4 shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
                                                <span>{brand.business_hours}</span>
                                            </div>
                                        )}
                                    </div>
                                </>
                            )}
                            {showNav && navLinks.length > 0 && (
                                <div className="mt-4 space-y-1">
                                    {navLinks.map(link => (
                                        <a key={link.id} href={link.href || `#${link.id}`} onClick={link.href ? undefined : e => smoothScroll(e, link.id)}
                                            className="block text-sm text-white/50 hover:text-white/80 transition-colors">{link.label}</a>
                                    ))}
                                </div>
                            )}
                        </div>
                        {/* Custom link columns */}
                        {linkColumns.map((col, ci) => {
                            const links = parseLinkCol(col);
                            if (links.length === 0 && !col.title) return null;
                            return (
                                <div key={ci}>
                                    {col.title && <h4 className="font-semibold mb-3">{col.title}</h4>}
                                    <div className="space-y-1">
                                        {links.map((link, li) => (
                                            <a key={li} {...resolveLinkProps(link.url)} className="block text-sm text-white/50 hover:text-white/80 transition-colors">{link.label}</a>
                                        ))}
                                    </div>
                                </div>
                            );
                        })}
                        <div>
                            {showSocial && socials.length > 0 && (
                                <>
                                    <h4 className="font-semibold mb-3">Redes sociales</h4>
                                    <div className="flex gap-3">
                                        {socials.map(([key, url]) => (
                                            <a key={key} href={url} target="_blank" rel="noopener noreferrer"
                                                className="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors">
                                                <SocialIcon type={key}/>
                                            </a>
                                        ))}
                                    </div>
                                </>
                            )}
                            {showNewsletter && (
                                <div className="mt-4">
                                    <h4 className="font-semibold mb-3">Suscribete</h4>
                                    <FooterNewsletter />
                                </div>
                            )}
                            {hasAppStores && (
                                <div className="mt-4">
                                    <h4 className="font-semibold mb-3">Descarga la app</h4>
                                    <AppStoreButtons {...appStoreProps}/>
                                </div>
                            )}
                        </div>
                    </div>
                    {showCopyright && (
                        <div className="mt-8 pt-6 border-t border-white/20 text-center text-sm text-white/50">
                            <p>{copyrightText}</p>
                            {(brand.privacy_url || brand.terms_url) && (
                                <div className="flex items-center justify-center gap-3 mt-2">
                                    {brand.privacy_url && <a href={brand.privacy_url} target="_blank" rel="noopener noreferrer" className="text-xs text-white/40 hover:text-white/70 transition-colors">Politica de Privacidad</a>}
                                    {brand.privacy_url && brand.terms_url && <span className="text-white/20">|</span>}
                                    {brand.terms_url && <a href={brand.terms_url} target="_blank" rel="noopener noreferrer" className="text-xs text-white/40 hover:text-white/70 transition-colors">Terminos y Condiciones</a>}
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </footer>
        </>
    );
}
